import {useTranslation} from "ni18n";
import React from "react";

import Flag from "../Flag";
import {Btn} from "../V5Comp";
import styles from "./Footer.module.scss";
import {Hdr} from "./Header";

const Footer = ({landingPageData, supportEmail}: any) => {
  const i18n = useTranslation();
  const {ctaLink} = landingPageData;
  return (
    <div className={styles.wrap}>
      <div className={styles.inner}>
        <div className={styles.c1}>
          <Hdr />
          <div style={{"--color": "#fff", "--hColor": "#ccc", marginTop: "1rem"}}>
            <Flag />
          </div>
        </div>
        <div className={styles.c2}>
          <div className={styles.a}>
            <Btn className={styles.a1} color="#1C4F75" bg="#f9f9f9" href={ctaLink}>
              {i18n.t("Get Started")}
            </Btn>
            <div className={styles.a2}>
              <div className={styles.a21}>{i18n.t("Having trouble registering? Contact")} </div>
              <div className={styles.a22}>
                <a href={`mailto:${supportEmail}`} className={styles.a23}>
                  {supportEmail}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
